import React from 'react';
import classnames from 'classnames';

import { enterpriseLogo } from '../../../assets';

import { LogoLink } from './LogoLink';
import { getLogoMarginStyles } from './logoUtils';
import { logoPropTypes } from './logoPropTypes';

import styles from './enterpriseLogo.module.css';

const PRESET_VARIANTS = ['login', 'splash', 'loader'];

export const EnterpriseLogo = ({
  md,
  lg,
  xl,
  className,
  onClick,
  variant,
  marginTop,
  marginBottom,
  marginOnImage = false,
}) => {
  const { hasCustomMargin, linkMarginStyle, imageMarginStyle } = getLogoMarginStyles(
    variant,
    marginTop,
    marginBottom,
    marginOnImage
  );

  const usePresetImageMargin = PRESET_VARIANTS.includes(variant) && (lg || xl);

  return (
    <LogoLink
      variant={variant}
      onClick={onClick}
      hasCustomMargin={hasCustomMargin}
      linkMarginStyle={linkMarginStyle}
    >
      <img
        src={enterpriseLogo}
        className={classnames({
          [styles.xl]: xl,
          [styles.lg]: lg,
          [styles.md]: md,
          [styles.presetReset]: usePresetImageMargin,
          [className]: className,
        })}
        style={imageMarginStyle}
        alt="MedHaul Enterprise logo"
      />
    </LogoLink>
  );
};

EnterpriseLogo.propTypes = logoPropTypes;
